var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"big-box"},[_c('PCHeaderNav'),_c('router-view'),_c('PCFooterInfo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }